export default "__VITE_PUBLIC_ASSET__d0668ff1__"